import { Checkbox, Label } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function CheckboxDemo() {
  return (
    <Section
      id="checkbox"
      title="Checkbox"
      description="Two-state checkbox. Pair with <Label> for screen-reader text."
    >
      <VariantBlock label="States">
        <div className="flex items-center gap-2">
          <Checkbox id="cb-unchecked" />
          <Label htmlFor="cb-unchecked">Unchecked</Label>
        </div>
        <div className="flex items-center gap-2">
          <Checkbox id="cb-checked" defaultChecked />
          <Label htmlFor="cb-checked">Checked (default)</Label>
        </div>
        <div className="flex items-center gap-2">
          <Checkbox id="cb-disabled" disabled />
          <Label htmlFor="cb-disabled">Disabled</Label>
        </div>
        <div className="flex items-center gap-2">
          <Checkbox id="cb-disabled-checked" disabled defaultChecked />
          <Label htmlFor="cb-disabled-checked">Disabled, checked</Label>
        </div>
        <div className="flex items-center gap-2">
          <Checkbox id="cb-invalid" aria-invalid />
          <Label htmlFor="cb-invalid">Invalid (aria)</Label>
        </div>
      </VariantBlock>
    </Section>
  );
}
